import { $, type Properties, resolve, signal } from "signlets";

import { debounce } from "../common";
import { ground } from "../elevation";
import { parseLocation } from "../geocode";
import type { Position } from "../model";
import { boundsCenter } from "../model";
import { positionEmpty } from "../position";

export type PointInputProps = {
  point: Position;
  onChangePoint: (_: Position) => void;
  onClick?: () => void;
  onBlur?: () => void;
};

export const PointInput = ({
  point,
  onChangePoint,
  onClick,
  onBlur,
}: Properties<PointInputProps>) => {
  const [valueString, setValueString] = signal<string | undefined>(undefined);

  const onEdited = debounce(() => setValueString(undefined), 2000);

  const positionString = (_: Position) => {
    if (positionEmpty(_)) return "";
    const [lon, lat] = _;
    return `${lat.toFixed(4)}, ${lon.toFixed(4)}`;
  };

  const onInput = async ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) => {
    const { value = "" } = currentTarget;
    setValueString(value);
    const bounds = value ? await parseLocation(value) : undefined;
    if (bounds) onChangePoint(await ground(boundsCenter(bounds)));
    onEdited();
  };

  const onFocus = ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) => currentTarget.select();

  const value = $(() => valueString() ?? positionString(resolve(point)));

  return (
    <input
      value={value}
      onInput={onInput}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
